var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c("gg-card-title", [
                _vm._v(
                  " Cancellation Request #" + _vm._s(_vm.cancellation.id) + " "
                )
              ])
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "billing"
                    }
                  }
                },
                [_vm._v("← Back to Billing")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                sm: "6"
              }
            },
            [
              _c(
                "gg-loading",
                {
                  staticClass: "fill-height",
                  attrs: {
                    loading: _vm.loading
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fill-height"
                    },
                    [
                      !_vm.loading
                        ? _c("cancellation-data", {
                            attrs: {
                              details: _vm.cancellation
                            },
                            on: {
                              "cancel-now": _vm.cancelNow,
                              "autorenew-now": function autorenewNow($event) {
                                _vm.autorenewConfirmModal = true
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                sm: "6"
              }
            },
            [
              _c(
                "gg-loading",
                {
                  staticClass: "fill-height",
                  attrs: {
                    loading: _vm.loading
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fill-height"
                    },
                    [
                      !_vm.loading
                        ? _c("reply", {
                            on: {
                              "post-added": _vm.getData
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-loading",
                {
                  staticClass: "fill-height",
                  attrs: {
                    loading: _vm.loading
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fill-height"
                    },
                    [
                      !_vm.loading
                        ? _c("cancellation-services", {
                            attrs: {
                              cr_services: _vm.cancellation.services
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: _vm.loading
                  }
                },
                [
                  _c(
                    "div",
                    [
                      !_vm.loading
                        ? _c("posts", {
                            attrs: {
                              posts: _vm.cancellation.replies
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.modalCancel
        },
        on: {
          close: _vm.closeCancelModal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Cancel Now ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [
                  _vm._v(
                    "You are indicating you want to cancel your service now instead of waiting until the due date."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "Proceeding will immediately delete the selected service and any associated records."
                  )
                ]),
                _c("p", [_vm._v("Are you sure you want to proceed?")])
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeCancelModal
                    }
                  },
                  [_vm._v(" No ")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.modalLoading
                    },
                    on: {
                      click: _vm.proceedCancelNow
                    }
                  },
                  [_vm._v(" Yes ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm.autorenewConfirmModal
        ? _c("autorenew-enable", {
            attrs: {
              "cr-id": _vm.crId
            },
            on: {
              close: _vm.autorenewCloseModal
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }